import { properties } from '../Properties';
import axios from 'axios';
import moment from 'moment';
import FileDownload from 'js-file-download';
import jwtDecode from 'jwt-decode';

export const authError = [401, 403];
const serviceUnavailable = {
                                status : 503,
                                body : {
                                validationMessages : [
                                        {
                                        description : "Service Unavailable"
                                        }
                                    ]
                                }
                            };

//Authentication
    export const authenticate = async (username,password,newPassword) => {
        if(username === "" && password === ""){
            return {
                status : 400,
                body : {
                validationMessages : [
                    {
                    message : "Please enter username and password",
                    description : "Please enter username and password"
                    }
                ]
                }
            }
        }
        else if (password === "") {
            return {
                status : 400,
                body : {
                validationMessages : [
                    {
                    message : "Please enter password",
                    description : "Please enter password"
                    }
                ]
                }
            }
        }
        else if (username === "") {
            return {
                status : 400,
                body : {
                validationMessages : [
                    {
                    message : "Please enter username",
                    description : "Please enter username"
                    }
                ]
                }
            }
        }
        const resource = {
                                username : username,
                                password : password,
                                newPassword : newPassword
                            }

        return await axios.post(properties.AUTHORIZATION_URL_ENDPOINT + '/api/lego-authorization/ext/cognito/signIn', resource)
                    .then(res => {
                        return res.data;
                    })
                    .catch(error => {
                        if (error.response){
                            return error.response.data;
                        } else {
                            return serviceUnavailable;
                        }
                    });
    }

    export const logout = async (username) => {
        const token = await getAccessToken();
        const accessToken = token.idToken;
        const authString = 'Bearer '.concat(accessToken); 
        const header =  { headers: { Authorization: authString } };
        const request = {
            username : username
        };
        return await axios.post(properties.AUTHORIZATION_URL_ENDPOINT + '/api/lego-authorization/ext/cognito/signOut',request ,header)
                    .then(res => {
                        return res.data;
                    })
                    .catch((error) => {
                        if (error.response){
                            return error.response.data;
                        } else {
                            return serviceUnavailable;
                        }
                    });
    }

    export const getAccessToken = async () => {
        const token = sessionStorage.getItem('lego_token');
        const {idToken, refreshToken, accessToken} = JSON.parse(token);
        const idPayload = jwtDecode(idToken);
        const iat = idPayload["iat"];
        const expDate = moment(new Date((iat + (1*60)) * 1000));

        let newToken;
        if(expDate.isBefore(moment())){
            const request = {
                refreshToken : refreshToken,
                accessToken : accessToken,
                idToken : idToken
            };
            newToken = await axios.post(properties.AUTHORIZATION_URL_ENDPOINT + '/api/lego-authorization/ext/cognito',request)
                        .then(res => {
                            const {body} = res.data;
                            return {idToken : body.idToken, 
                                    refreshToken : refreshToken, 
                                    accessToken : body.accessToken};
                        })
                        .catch((error) => {
                            return {idToken, refreshToken, accessToken};
                        });
        } else {
            newToken = {idToken, refreshToken, accessToken};
        }
        sessionStorage.setItem('lego_token',JSON.stringify(newToken));
        return newToken;
    }

    export const updateMerchantProfile = async (resource) => {
        const token = await getAccessToken();
        const accessToken = token.idToken;
        const authString = 'Bearer '.concat(accessToken); 
        const header =  { headers: { Authorization: authString } };
        const endpointPath = '/api/lego-changehandler/ext/changehandler/';  

        return await axios.put(properties.CHANGEHANDLER_URL_ENDPOINT + endpointPath, resource, header)
                    .then(res => {
                        return res.data;
                    })
                    .catch(error => {
                        if (error.response){
                            return error.response.data;
                        } else {
                            return serviceUnavailable;
                        }
                    });
    }

    export const getMerchantProfileDetail = async () => {
        const token = await getAccessToken();
        const accessToken = token.idToken;
        const authString = 'Bearer '.concat(accessToken); 
        const header =  { headers: { Authorization: authString } };

        return await axios.get(properties.CHANGEHANDLER_URL_ENDPOINT + '/api/lego-changehandler/ext/changehandler/profile/', header)
                            .then(res => {
                            return res.data;
                            })
                            .catch(error => {
                                if (error.response){
                                    return error.response.data;
                                } else {
                                    return serviceUnavailable;
                                }
                            });
    }

    export const downloadPublicKey = async () => {
        const token = await getAccessToken();
        const accessToken = token.idToken;
        const authString = 'Bearer '.concat(accessToken);
        const header =  
            {                 
                responseType: 'blob',
                headers: { 
                    Authorization: authString
                } 
            };
    
        return await axios.get(properties.AUTHENTICATION_URL_ENDPOINT + '/api/lego-authentication/ext/keypairs', header)
                    .then(res => {
                        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                        const contentDisposition = res.headers["content-disposition"];
                        const match = contentDisposition.match(filenameRegex);
    
                        FileDownload(res.data, match[1]);
                        return {
                            status : 200
                        }
                    })
                    .catch(error => {
                        if (error.response){
                            return error.response.data;
                        } else {
                            return serviceUnavailable;
                        }
                    });
    }

//USER PROFILE
export const getUserList = async (filterCriteria) => {
    const token = await getAccessToken();
    const accessToken = token.idToken;
    const authString = 'Bearer '.concat(accessToken);
    const header =  { headers: { Authorization: authString } };
    const request = {
        merchantId: filterCriteria.merchantId,
        merchantCode: filterCriteria.merchantCode,
        merchantName: filterCriteria.merchantName,
        username: filterCriteria.username,
        status: filterCriteria.status,
        page : filterCriteria.tableFilter.page,
        sizePerPage : filterCriteria.tableFilter.sizePerPage,
        sortingColumn : filterCriteria.tableFilter.sortField,
        sortingType : filterCriteria.tableFilter.sortOrder
    }

    return await axios.post(properties.USERPROFILE_URL_ENDPOINT + '/api/lego-userprofile/ext/users',request, header)
                .then(res => {
                    return res.data;
                })
                .catch(error => {
                    if (error.response){
                        return error.response.data;
                    } else {
                        return serviceUnavailable;
                    }
                });
}

export const getUser = async (merchantId, userId) => {
    const token = await getAccessToken();
    const accessToken = token.idToken;
    const authString = 'Bearer '.concat(accessToken);
    const header =  { headers: { Authorization: authString } };

    const request = {
        merchantId : merchantId,
        userId : userId
    };

    return await axios.post(properties.USERPROFILE_URL_ENDPOINT + '/api/lego-userprofile/ext/user/details', request, header)
                .then(res => {
                    return res.data;
                })
                .catch(error => {
                    if (error.response){
                        return error.response.data;
                    } else {
                        return serviceUnavailable;
                    }
                });
}

export const forgotPassword = async (username) => {
    const request = {
        username : username
    };
    return await axios.post(properties.USERPROFILE_URL_ENDPOINT + '/api/lego-userprofile/ext/user/forgot', request)
                .then(res => {
                    return res.data;
                })
                .catch(error => {
                    if (error.response){
                        return error.response.data;
                    } else {
                        return serviceUnavailable;
                    }
                });
}

export const changePassword = async (cpToken, currentPassword, newPassword) => {
    const token = await getAccessToken();
    const accessToken = token.idToken;
    const authString = 'Bearer '.concat(accessToken);
    const header =  { headers: { Authorization: authString } };

    const request = {
        accessToken : cpToken,
        currentPassword : currentPassword,
        newPassword : newPassword
    };
    return await axios.post(properties.USERPROFILE_URL_ENDPOINT + '/api/lego-userprofile/ext/user/change', request, header)
                .then(res => {
                    return res.data;
                })
                .catch(error => {
                    if (error.response){
                        return error.response.data;
                    } else {
                        return serviceUnavailable;
                    }
                });
}

export const createUser = async (userProfile) => {
    const token = await getAccessToken();
    const accessToken = token.idToken;
    const authString = 'Bearer '.concat(accessToken);
    const header =  { headers: { Authorization: authString } };
    const request = {
        action : 'CREATE',
        userProfile : {...userProfile, status:"A"}
    };   

    return await axios.post(properties.USERPROFILE_URL_ENDPOINT + '/api/lego-userhandler/ext/userhandler/', request, header)
                    .then(res => {
                        return res.data;
                    })
                    .catch(error => {
                        if (error.response){
                            return error.response.data;
                        } else {
                            return serviceUnavailable;
                        }
                    });
}

export const updateUser = async (action, userProfile) => {
    const token = await getAccessToken();
    const accessToken = token.idToken;
    const authString = 'Bearer '.concat(accessToken);
    const header =  { headers: { Authorization: authString } };
    const request = {
        action : action,
        userProfile : userProfile
    };

    return await axios.put(properties.USERPROFILE_URL_ENDPOINT + '/api/lego-userhandler/ext/userhandler/', request, header)
                .then(res => {
                    return res.data;
                })
                .catch(error => {
                    if (error.response){
                        return error.response.data;
                    } else {
                        return serviceUnavailable;
                    }
                });
}

export const updateLastLogin = async (userId) => {
    const token = await getAccessToken();
    const accessToken = token.idToken;
    const authString = 'Bearer '.concat(accessToken); 
    const header =  { headers: { Authorization: authString } };

    return await axios.put(properties.USERPROFILE_URL_ENDPOINT + '/api/lego-userhandler/ext/userhandler/lastlogin/' + userId, null, header)
                    .then(res => {
                        return res.data;
                    })
                    .catch(error => {
                        if (error.response){
                            return error.response.data;
                        } else {
                            return serviceUnavailable;
                        }
                    });
}

//CUSTOMER PROFILE
export const getCustomerList = async (filterCriteria) => {
    const token = await getAccessToken();
    const accessToken = token.idToken;
    const authString = 'Bearer '.concat(accessToken);
    const header =  { headers: { Authorization: authString } };
    const request = {
        merchantId: filterCriteria.merchantId,
        merchantName: filterCriteria.merchantName,
        userId: filterCriteria.userId,
        bankAccount: filterCriteria.bankAccount,
        currencyName: filterCriteria.currencyName,
        page : filterCriteria.tableFilter.page,
        sizePerPage : filterCriteria.tableFilter.sizePerPage,
        sortingColumn : filterCriteria.tableFilter.sortField,
        sortingType : filterCriteria.tableFilter.sortOrder
    }

    return await axios.post(properties.CUSTOMERPROFILE_URL_ENDPOINT + '/api/lego-customerprofile/ext/customerprofile/list',request, header)
                .then(res => {
                    return res.data;
                })
                .catch(error => {
                    if (error.response){
                        return error.response.data;
                    } else {
                        return serviceUnavailable;
                    }
                });
}

export const getCustomer = async (custProfileId) => {
    const token = await getAccessToken();
    const accessToken = token.idToken;
    const authString = 'Bearer '.concat(accessToken);
    const header =  { headers: { Authorization: authString } };

    return await axios.get(properties.CUSTOMERPROFILE_URL_ENDPOINT + '/api/lego-customerprofile/ext/handler/' + custProfileId , header)
                .then(res => {
                    return res.data;
                })
                .catch(error => {
                    if (error.response){
                        return error.response.data;
                    } else {
                        return serviceUnavailable;
                    }
                });
}

// REPORT
export const getTransaction = async (mode, filterCriteria) => {
    const token = await getAccessToken();
    const accessToken = token.idToken;
    const authString = 'Bearer '.concat(accessToken);
    const header =  { headers: { Authorization: authString } };

    const request = {
        txnNumber : filterCriteria.transactionNo,
        merchantId: filterCriteria.merchantId,
        merchantName : filterCriteria.merchantName,
        refNumber: filterCriteria.merchantRef,
        fromAcctNo: filterCriteria.payerAccount,
        customerRef: filterCriteria.merchantCustNo,
        fromDate: filterCriteria.fromDate,
        toDate: filterCriteria.toDate,
        statusCodes: filterCriteria.txnStatusCode === "" ? [] : [filterCriteria.txnStatusCode],
        pageSize: filterCriteria.tableFilter.sizePerPage,
        pageNo: filterCriteria.tableFilter.page,
        sortField: filterCriteria.tableFilter.sortField,
        sortDirection: filterCriteria.tableFilter.sortOrder
    }

    const apiPath = '/api/lego-report/ext/transaction/list';
    return await axios.post(properties.REPORT_URL_ENDPOINT + apiPath,request, header)
                .then(res => {
                    return res.data;
                })
                .catch(error => {
                    if (error.response){
                        return error.response.data;
                    } else {
                        return serviceUnavailable;
                    }
                });
}

export const getTransactionReport = async (filterCriteria) => {
    const token = await getAccessToken();
    const accessToken = token.idToken;
    const authString = 'Bearer '.concat(accessToken);
    const header =  
        {                 
            responseType: 'blob',
            headers: { 
                Authorization: authString
            } 
        };

    const request = {
        reportType : "csv",
        transactionCriteria : {
            txnNumber : filterCriteria.transactionNo,
            merchantId: filterCriteria.merchantId,
            merchantName : filterCriteria.merchantName,
            refNumber: filterCriteria.merchantRef,
            fromAcctNo: filterCriteria.payerAccount,
            customerRef: filterCriteria.merchantCustNo,
            fromDate: filterCriteria.fromDate,
            toDate: filterCriteria.toDate,
            statusCodes: filterCriteria.txnStatusCode === "" ? [] : [filterCriteria.txnStatusCode],
            pageSize: filterCriteria.tableFilter.sizePerPage,
            pageNo: filterCriteria.tableFilter.page,
            sortField: filterCriteria.tableFilter.sortField,
            sortDirection: filterCriteria.tableFilter.sortOrder
        }
    }

    return await axios.post(properties.REPORT_URL_ENDPOINT + '/api/lego-report/ext/transaction/download',request, header)
                .then(res => {
                    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    const contentDisposition = res.headers["content-disposition"];
                    const match = contentDisposition.match(filenameRegex);

                    FileDownload(res.data, match[1]);
                    return {
                        status : 200
                    }
                })
                .catch(error => {
                    if (error.response){
                        return error.response.data;
                    } else {
                        return serviceUnavailable;
                    }
                });
}

export const getTransactionDetail = async (merchantId, txnNumber) => {
    const token = await getAccessToken();
    const accessToken = token.idToken;
    const authString = 'Bearer '.concat(accessToken);
    const header =  { headers: { Authorization: authString } };

    const request = {
        merchantId: merchantId,
        txnNumber: txnNumber
    }

    return await axios.post(properties.REPORT_URL_ENDPOINT + '/api/lego-report/ext/transaction',request, header)
                .then(res => {
                    return res.data;
                })
                .catch(error => {
                    if (error.response){
                        return error.response.data;
                    } else {
                        return serviceUnavailable;
                    }
                });
}

export const getRegistrationReport = async (mode, filterCriteria) => {
    const token = await getAccessToken();
    const accessToken = token.idToken;
    const authString = 'Bearer '.concat(accessToken);
    const header =  { headers: { Authorization: authString } };

    const request = {
        customerRegFlag: mode,
        merchantId: filterCriteria.merchantId,
        merchantName: filterCriteria.merchantName,
        fromDate: filterCriteria.fromDate,
        toDate: filterCriteria.toDate,
        customerReference: filterCriteria.merchantCustNo,
        customerAcctNo: filterCriteria.payerAccount,
        customerAcctCurrency: filterCriteria.customerAcctCurrency,
        registerChannel: filterCriteria.channel,
        statusCode: filterCriteria.statusCode,
        pageSize: filterCriteria.tableFilter.sizePerPage,
        pageNo: filterCriteria.tableFilter.page,
        sortField: filterCriteria.tableFilter.sortField,
        sortDirection: filterCriteria.tableFilter.sortOrder
    }

    const apiPath = '/api/lego-report/ext/registration/list';
    return await axios.post(properties.REPORT_URL_ENDPOINT + apiPath,request, header)
                .then(res => {
                    return res.data;
                })
                .catch(error => {
                    if (error.response){
                        return error.response.data;
                    } else {
                        return serviceUnavailable;
                    }
                });
}

export const getExportRegistrationReport = async (mode, filterCriteria) => {
    const token = await getAccessToken();
    const accessToken = token.idToken;
    const authString = 'Bearer '.concat(accessToken);
    const header =  
        {                 
            responseType: 'blob',
            headers: { 
                Authorization: authString
            } 
        };

    const request = {
        reportType : "csv",
        registrationCriteria : {
            customerRegFlag: mode,
            merchantId: filterCriteria.merchantId,
            merchantName: filterCriteria.merchantName,
            fromDate: filterCriteria.fromDate,
            toDate: filterCriteria.toDate,
            customerReference: filterCriteria.merchantCustNo,
            customerAcctNo: filterCriteria.payerAccount,
            customerAcctCurrency: filterCriteria.customerAcctCurrency,
            registerChannel: filterCriteria.channel,
            statusCode: filterCriteria.statusCode,
            pageSize: filterCriteria.tableFilter.sizePerPage,
            pageNo: filterCriteria.tableFilter.page,
            sortField: filterCriteria.tableFilter.sortField,
            sortDirection: filterCriteria.tableFilter.sortOrder
        }
    }

    return await axios.post(properties.REPORT_URL_ENDPOINT + '/api/lego-report/ext/registration/download',request, header)
                .then(res => {
                    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    const contentDisposition = res.headers["content-disposition"];
                    const match = contentDisposition.match(filenameRegex);

                    FileDownload(res.data, match[1]);
                    return {
                        status : 200
                    }
                })
                .catch(error => {
                    if (error.response){
                        return error.response.data;
                    } else {
                        return serviceUnavailable;
                    }
                });
}


export const downloadSso250ReportByReportDate = async (reportDate) => {
    const token = await getAccessToken();
    const accessToken = token.idToken;
    const authString = 'Bearer '.concat(accessToken);
    const header =  
        {                 
            responseType: 'blob',
            headers: { 
                Authorization: authString
            } 
        };

    const request = {
        reportType : "csv",
        sso250Criteria : {
            reportDate : reportDate
        }
    }

    return await axios.post(properties.REPORT_URL_ENDPOINT + '/api/lego-report/ext/sso-250/download',request, header)
                .then(res => {
                    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    const contentDisposition = res.headers["content-disposition"];
                    const match = contentDisposition.match(filenameRegex);

                    FileDownload(res.data, match[1]);
                    return {
                        status : 200
                    }
                })
                .catch(error => {
                    console.log(error.response)
                    if (error.response){
                        return {
                            status : error.response.status
                        }
                    } else {
                        return serviceUnavailable;
                    }
                });
}